import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  menu: any = {};

  constructor(private _authService: AuthService) {
    try {
      this.menu = JSON.parse(this._authService.userProfile.role.menu);
      this._authService.reload.subscribe((_menuRole : any) => {

        this.menu = JSON.parse(this._authService.userProfile.role.menu);
      });
    } catch (e) {
      this.menu = null;
    }
  }

  getMenu(id?) {
    if (id) {
      return this.menu?.find(o => o?.id === id);
    }
    return this.menu;
  }

  buttonPermission(): any {
    return {
      level1: (id, page, action) => {
        try {
          let getmenu = JSON.parse(this._authService.userProfile.role.menu);
          const _menu = getmenu.filter(i => i.id === id)[0];

          if (_menu) {
            const _page = _menu.pages.filter(i => i.code === page)[0];

            if (_page) {
              const _button = _page.buttons.filter(i => i.action === action)[0];

              return !!_button;
            }
          }

          return false;
        } catch (e) {
          return false;
        }
      }
    };
  }

  menuPermission(): any {
    const _menuRole =  (!this._authService.userProfile)? [] : JSON.parse(this._authService.userProfile.role.menu);
    return {
      level1: (id) => {
        try {
          // const _menu = this.menu.filter(i => i.id === id)[0];
          const _menu = _menuRole.filter(i => i.id === id)[0];
          return !!_menu;
        } catch (e) {
          return false;
        }
      },
      level2: (level1, id) => {
        try {
          const _parent = _menuRole.filter(i => i.id === level1)[0];
          // const _parent = this.menu.filter(i => i.id === level1)[0];

          if (_parent) {
            const _children = _parent.children.filter(i => i.id === id)[0];

            return !!_children;
          }

          return false;
        } catch (e) {
          return false;
        }
      }
    };
  }
}
